import clsx from 'clsx';
import { Collapsible as CollapsiblePrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';

type RootProps = ComponentProps<typeof CollapsiblePrimitive.Root>;

const HubertCollapsible = ({ children, ...props }: RootProps) => {
  return <CollapsiblePrimitive.Root {...props}>{children}</CollapsiblePrimitive.Root>;
};

type TriggerProps = ComponentProps<typeof CollapsiblePrimitive.Trigger>;

const Trigger = ({ children, ...props }: TriggerProps) => {
  return <CollapsiblePrimitive.Trigger {...props}>{children}</CollapsiblePrimitive.Trigger>;
};

type ContentProps = ComponentProps<typeof CollapsiblePrimitive.Content>;

const Content = ({ children, ...props }: ContentProps) => {
  return (
    <CollapsiblePrimitive.Content
      {...props}
      className={clsx(
        props.className,
        'data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down overflow-hidden transition-all',
      )}
    >
      {children}
    </CollapsiblePrimitive.Content>
  );
};

HubertCollapsible.Trigger = Trigger;
HubertCollapsible.Content = Content;
export default HubertCollapsible;
